import React from 'react';
import UserProfile from './UserProfile';
import AdminPanel from './AdminPanel';
import './Home.css';

function Home({ currentView }) {
  // 사용자 프로필 화면
  if (currentView === 'profile') {
    return <UserProfile />;
  }

  // 관리자 패널 화면
  if (currentView === 'admin') {
    return <AdminPanel />;
  }

  // 예전 임금대장 화면(SalaryManagement)은 더 열지 않는다(deprecated). 임금대장은 components/payroll 이다
  return null;
}

export default Home;